import React, { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import ModuleSummaryCard from "./ModuleSummaryCard";
import { ModulesContext, isModuleActive } from "../../utils/ModulesContext";
import api from "../../utils/api";

const MONTH_NAMES = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

const CARDS = [
  { key: "workorders", title: "Work Orders", viewAllLink: "/home/workorders", moduleId: 1 },
  { key: "violations", title: "Violations", viewAllLink: "/home/violations", moduleId: 2 },
  { key: "architectural", title: "Architectural Requests", viewAllLink: "/home/architecturalrequest", moduleId: 3 },
];

const ModuleSummaryCards = () => {
  const { modules } = useContext(ModulesContext);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    api.get("/dashboard/module-summary").then((res) => setSummary(res.data)).catch(() => {});
  }, []);

  if (!summary) return null;

  const now = new Date();
  const lastYearLabel = `${MONTH_NAMES[now.getMonth()]} ${now.getFullYear() - 1}`;

  const visibleCards = CARDS.filter((c) => isModuleActive(modules, c.moduleId) && summary[c.key]);
  if (visibleCards.length === 0) return null;

  return (
    <Box sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: `repeat(${visibleCards.length}, 1fr)` },
      gap: 2.5, mb: 3,
    }}>
      {visibleCards.map((c) => (
        <ModuleSummaryCard
          key={c.key}
          title={c.title}
          viewAllLink={c.viewAllLink}
          data={summary[c.key]}
          lastYearLabel={lastYearLabel}
        />
      ))}
    </Box>
  );
};

export default ModuleSummaryCards;
